document.addEventListener('DOMContentLoaded', function () {
  imageMapResize();

  // image map area smooth scroll
  document.querySelectorAll('area[href^="#"]').forEach(function (area) {
    area.addEventListener('click', function (e) {
      e.preventDefault();
      var targetId = area.getAttribute('href');
      var target = document.querySelector(targetId);
      if (!target) return;
      var header = document.querySelector('.header');
      var headerHeight = header ? header.offsetHeight : 0;
      var targetTop = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top: targetTop, behavior: 'smooth' });
    });
  });

  // haneda tab
  var hanedaBtns = document.querySelectorAll('.haneda-tab__btn');
  var hanedaPanels = document.querySelectorAll('.haneda-tab__panel');
  hanedaBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tab;
      hanedaBtns.forEach(function (b) {
        b.classList.remove('is-active');
      });
      hanedaPanels.forEach(function (p) {
        p.classList.remove('is-active');
      });
      this.classList.add('is-active');
      document.querySelector('.haneda-tab__panel[data-panel="' + target + '"]').classList.add('is-active');
    });
  });

  // narita tab
  var naritaBtns = document.querySelectorAll('.narita-tab__btn');
  var naritaPanels = document.querySelectorAll('.narita-tab__panel');
  naritaBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = this.dataset.tab;
      naritaBtns.forEach(function (b) {
        b.classList.remove('is-active');
      });
      naritaPanels.forEach(function (p) {
        p.classList.remove('is-active');
      });
      this.classList.add('is-active');
      document.querySelector('.narita-tab__panel[data-panel="' + target + '"]').classList.add('is-active');
    });
  });
});
